import React, { useState, useCallback, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useLocation } from 'react-router-dom';

import { Form, WrapperContent } from "./styles";
import { SearchField, SubmitSearch } from "../../../components/design/layout/search";
import HeaderPage from "../../../components/patterns/subpages/header";
import { Menu, MenuItem } from '../../../components/ui/menu';

import StateService from '../../../services/State';

const useStyles = makeStyles(() => ({
    item: {
        borderBottom: `1px solid #F5F5F5`,
        height: `${42}px !important`
    }
}));

function ListStates() {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const search = new URLSearchParams(location.search);

    const [states, setStates] = useState([]);
    const [statesFiltered, setStatesFiltered] = useState(undefined);
    const [pathToSend, setPathToSend] = useState(undefined)

    const handleSelectState = ({ sigla }) => {
        search.set('uf', sigla);
        history.push({ pathname: pathToSend? pathToSend: '/', search: search.toString() })
    };

    const handleListStates = useCallback(() => {
        const stateService = new StateService();

        if(location.state && location.state.prevPath) {
            setPathToSend(location.state.prevPath)
        }

        stateService.list({}).then((response) => {
            setStates(response.data.payload);
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        handleListStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const filterStateList = (e) => {
        e.preventDefault();
        let search = e.target.value? e.target.value: e.target.search?.value;

        if(search) {
            setStatesFiltered(states.filter((state) => state.nome.toLowerCase().indexOf(search.toLowerCase()) >= 0 ));
        } else {
            setStatesFiltered(undefined);
        }
        
    };

    return (
        <>
            <HeaderPage borderBottom={true}>
                <Form onSubmit={(e) => filterStateList(e)}>
                    <SearchField
                        placeholder={`Qual seu estado?`}
                        type="text"
                        name="search"
                        onChange={(e) => filterStateList(e)}
                    />

                    <SubmitSearch type="submit" />
                </Form>
            </HeaderPage>

            <WrapperContent>
                <Menu>

                    {statesFiltered? 
                        statesFiltered.map((item) => (
                            <MenuItem 
                                className={classes.item} 
                                withArrowIcon={true} 
                                title={item.nome} 
                                onClick={() => handleSelectState({sigla: item.sigla})} 
                            />
                        )):
                        
                        states.map((item) => (
                            <MenuItem 
                                className={classes.item} 
                                withArrowIcon={true} 
                                title={item.nome} 
                                onClick={() => handleSelectState({sigla: item.sigla})} 
                            />
                        ))
                    }

                </Menu>
            </WrapperContent>
        </>
    )
}

export default ListStates;